import React from "react"
import { useShallow } from "zustand/react/shallow"
import { capitalize } from "lodash"

// components
import { TextInput } from "components-design-system"

// context
import useAuthoringViewStore from "containers/studies/Study/subcomponents/Authoring/hooks/stores/useAuthoringViewStore"

const DispersionInputs = ({ parameterType, dispersionType, dispersionValue, cell, cellArmId, onChange }) => {
  const { readOnly } = useAuthoringViewStore(
    useShallow((state) => ({
      readOnly: state.readOnly,
    }))
  )

  return (
    <div
      className="flex flex-col"
      style={{ gap: 16 }}
    >
      <TextInput
        label={capitalize(parameterType)}
        readOnly={readOnly}
        onChange={(e) => onChange(e.target.value, cellArmId, "value")}
        value={cell.value}
      />
      <TextInput
        label={capitalize(dispersionType)}
        readOnly={readOnly}
        onChange={(e) => onChange(e.target.value, cellArmId, "dispersion_value")}
        value={dispersionValue}
      />
    </div>
  )
}

export default DispersionInputs
